import React from 'react';
import { ControlUnitAPIResponse } from '../../../../../../redux/controlUnit/api/ControlUnit.model';
import { useCurrentStateByControlUnitId } from '../../../../../../redux/controlUnit/hooks/useCurrentStateByControlUnitId';
import SetPoint from './SetPoint';

interface SetPointsProps {
  controlUnit: ControlUnitAPIResponse | undefined;
  deviceId: string;
  setPoints: ReturnType<typeof useCurrentStateByControlUnitId>['setPoints'];
  CUTranslate: ReturnType<typeof useCurrentStateByControlUnitId>['CUTranslate'];
}
export default function SetPoints(props: SetPointsProps) {
  const { controlUnit, deviceId, setPoints } = props;
  return controlUnit && setPoints?.length ? (
    <div className="ControlUnit-SetPoints-container">
      {setPoints.map((setPoint) => (
        <SetPoint
          key={setPoint.setPoint.id}
          {...props}
          composedSetPoint={setPoint}
          controlUnit={controlUnit}
          deviceId={deviceId}
        />
      ))}
    </div>
  ) : null;
}
